// Bundle shapes differ by where the order came from: the POS keys a bundle's
// items by slot, the ordering website sends a plain array. Callers only ever
// want an array.
const toItemArray = (items) => {
  if (Array.isArray(items)) return items;
  if (items && typeof items === 'object') return Object.values(items);
  return [];
};

// Build the editable bundle list the amend modal works on.
//
// This MUST be a deep copy. The modal previously seeded its draft with
// `order.bundles` directly and then edited item objects in place, so every
// quantity change rewrote the live order and the "original" half of the audit
// trail at the same time. Reducing an item to zero wiped the order to GHS 0
// while it sat in the kitchen, with no record of what had been removed.
export const cloneBundlesForAmend = (order, fallbackPackaging = 'rubber') => {
  const bundles = Array.isArray(order?.bundles) ? order.bundles : null;

  if (bundles && bundles.length > 0) {
    return bundles.map((bundle) => ({
      ...bundle,
      items: toItemArray(bundle?.items).map((item) => ({ ...item })),
    }));
  }

  return [{
    id: Date.now(),
    name: 'Package 1',
    items: toItemArray(order?.items).map((item) => ({ ...item })),
    packaging: order?.packaging || fallbackPackaging,
  }];
};
